module.exports = __webpack_public_path__ + "img/video-block-es.c8ceca56.png";